import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectUserState } from "../app/slices/userSlice";

export const useUserAuth = () => {
    const userData = useSelector(selectUserState);
    return useMemo(() => userData, [ userData ]);
}